module.exports = __webpack_public_path__ + "img/131.decaaeb0.jpg";